class VariantOptionSlider extends HTMLElement {
  constructor() {
    super();

    this.elements = {
      contentToggler: this.querySelector('[data-toggle-content]'),
      content: this.querySelector('[data-content]'),
      imageWrappers: this.querySelectorAll('variant-option-slide-image-wrapper'),
      descriptions: this.querySelectorAll('variant-option-slide-description'),
      slider: this.querySelector('[data-images-slider]'),
      sliderElement: this.querySelector('slider-element'),
    }

    this.elements.contentToggler.addEventListener('click', this.toggleContent.bind(this));

    if (this.elements.imageWrappers.length) {
      this.elements.imageWrappers.forEach(
        (imageWrapper) => imageWrapper.addEventListener('VariantOptionSlideImageWrapperClicked', this.handleImageWrapperClick.bind(this))
      );
    }
  }

  connectedCallback() {
    this.updateSliderPosition();
  }

  toggleContent() {
    this.elements.contentToggler.classList.toggle('opened');
    this.elements.content.slideToggle();
    this.updateSliderPosition();
  }

  openContent() {
    this.elements.contentToggler.classList.add('opened');
    this.elements.content.style.display = 'block';
    this.updateSliderPosition();
  }

  updateSliderPosition() {
    if (this.elements.imageWrappers.length) {
      const activeImageWrapper = Array.from(this.elements.imageWrappers).find((imageWrapper) =>  imageWrapper.classList.contains('active'));

      setTimeout(() => {
        this.elements.sliderElement.select(activeImageWrapper.dataset.index - 1, true);
      }, 100);
    }
  }

  handleImageWrapperClick(event) {
    const activeItemIndex = event.detail.index;
    this.elements.imageWrappers.forEach(
      (imageWrapper) => {
        if (activeItemIndex == imageWrapper.index) {
          imageWrapper.classList.add('active');
        } else {
          imageWrapper.classList.remove('active');
        }
      }
    );

    this.elements.descriptions.forEach(
      (description) => {
        if (activeItemIndex == description.index) {
          description.classList.add('active');
        } else {
          description.classList.remove('active');
        }
      }
    );
  }
}

customElements.define('variant-option-slider', VariantOptionSlider);

class VariantOptionSlideImageWrapper extends HTMLElement {
  constructor() {
    super();
    this.index = parseInt(this.dataset.index);
    this.variantId = parseInt(this.dataset.variantId);
    this.productUrl = this.dataset.productUrl;
    this.elements = {
      image: this.querySelector('[data-variant-option-slide-image]'),
    }

    this.addEventListener('click', this.handleClick.bind(this));
  }

  handleClick() {
    this.dispatchEvent(new CustomEvent('VariantOptionSlideImageWrapperClicked', {
      detail: {
        index: this.index,
      }
    }));
  }
}

customElements.define('variant-option-slide-image-wrapper', VariantOptionSlideImageWrapper);

class VariantOptionSlideDescription extends HTMLElement {
  constructor() {
    super();

    this.index = this.dataset.index;
  }
}

customElements.define('variant-option-slide-description', VariantOptionSlideDescription);